export const newsData = [
  {
    id: 43,
    title: "理科大発スタートアップに認定されました",
    summary: "東京理科大学発のスタートアップとして正式に認定を受けました",
    content: "株式会社DeepTeLLは、東京理科大学発のスタートアップとして正式に認定されました。これにより、大学との連携をさらに強化し、研究開発や人材育成において新たな取り組みを推進してまいります。",
    date: "2025年5月27日",
    category: "認定",
    author: "広報部",
    tags: ["東京理科大学", "スタートアップ", "認定"],
    views: 0
  },
  {
    id: 42,
    title: "カスタムSLM「Hamster」資料を公開",
    summary: "軽量でセキュアな専用言語モデル_AIエージェント_チャットボット_マッチングアプリ構築のコアパッケージ資料を公開",
    content: "カスタムSLM「Hamster」の技術資料を公開いたします。軽量でセキュアな専用言語モデルとして、AIエージェント、チャットボット、マッチングアプリ構築のコアパッケージとしてご活用いただけます。",
    date: "2025年4月3日",
    category: "技術",
    author: "技術広報",
    tags: ["SLM", "Hamster", "言語モデル", "チャットボット"],
    views: 0,
    url: "https://slideshare.net/slideshow/slm-hamster--ai--/277485004"
  },
  {
    id: 41,
    title: "量子リザバソフトウェア効果検証資料を公開",
    summary: "時系列データ（農業・エネルギー・金融・製造・需要予測など）効果検証_導入による成果資料を公開",
    content: "量子リザバソフトウェアの時系列データ解析における効果検証結果をまとめた資料を公開いたします。農業、エネルギー、金融、製造、需要予測等の各分野での導入成果をご確認いただけます。",
    date: "2025年4月3日",
    category: "技術",
    author: "技術広報",
    tags: ["量子リザバ", "時系列予測", "効果検証"],
    views: 0,
    url: "https://slideshare.net/slideshow/-/277447960"
  },
  {
    id: 40,
    title: "LBAIの二次代理店になりました",
    summary: "LBAI（@LB__AI）の二次代理店として業務開始",
    content: "株式会社DeepTeLLは、LBAI（@LB__AI）の二次代理店として正式に契約を締結いたしました。これにより、LBAIのサービスを通じてより幅広いクライアント様にAIソリューションを提供できるようになります。",
    date: "2025年3月10日",
    category: "事業展開",
    author: "事業開発部",
    tags: ["LBAI", "代理店", "パートナーシップ"],
    views: 0
  },
  {
    id: 39,
    title: "丹治光太郎がCTOに就任しました",
    summary: "新たな支店「ボルバキア支店」を開設",
    content: "株式会社DeepTeLLは、丹治光太郎をCTOとして任命し、新たな拠点として「ボルバキア支店」を開設いたしました。地域密着型のサービス提供により、より細やかなサポートを実現してまいります。",
    date: "2025年2月8日",
    category: "事業展開",
    author: "経営企画部",
    tags: ["支店開設", "ボルバキア", "拠点拡大"],
    views: 0
  },
  {
    id: 38,
    title: "Office Allzen.様と業務提携を行いました",
    summary: "オフィス・オールゼン様との業務提携により、専門サービスの提供を開始",
    content: "株式会社DeepTeLLは、Office Allzen.様と業務提携を締結いたしました。当社の谷前太喜、杉本迅が専門家として参画し、より専門性の高いサービスをご提供してまいります。",
    date: "2025年1月19日",
    category: "事業展開",
    author: "事業開発部",
    tags: ["業務提携", "Office Allzen", "専門家"],
    views: 0,
    urls: [
      "https://allzen.jp/?post_type=expert&p=208&preview=true",
      "https://allzen.jp/?post_type=expert&p=211&preview=true"
    ]
  },
  {
    id: 37,
    title: "AWS Partner Networkに採択",
    summary: "AWS Partner Networkのパートナーとして正式に採択されました",
    content: "株式会社DeepTeLLは、Amazon Web Services（AWS）のPartner Networkに正式に採択されました。これにより、AWSクラウドサービスを活用したより高品質なソリューションの提供が可能となります。",
    date: "2024年12月31日",
    category: "認定",
    author: "技術広報",
    tags: ["AWS", "パートナー", "クラウド"],
    views: 0
  },
  {
    id: 36,
    title: "IBM Partner Plusに採択",
    summary: "IBM Partner Plusパートナーとして正式に採択されました",
    content: "株式会社DeepTeLLは、IBM Partner Plusのパートナーとして正式に採択されました。IBMの先進技術を活用し、企業向けソリューションのさらなる強化を図ってまいります。",
    date: "2024年12月31日",
    category: "認定",
    author: "技術広報",
    tags: ["IBM", "パートナー", "エンタープライズ"],
    views: 0
  },
  {
    id: 35,
    title: "ホームページを更新",
    summary: "動画付きのコンテンツでホームページをリニューアルしました",
    content: "株式会社DeepTeLLのホームページを大幅にリニューアルいたしました。動画コンテンツを追加し、より分かりやすく魅力的なサイトに生まれ変わりました。",
    date: "2024年12月24日",
    category: "アップデート",
    author: "広報部",
    tags: ["ホームページ", "リニューアル", "動画"],
    views: 0,
    url: "https://deeptell.co.jp"
  },
  {
    id: 34,
    title: "RENEW MEDIA YouTube動画公開（起業理由編）",
    summary: "3度の詐欺・死にかけた体験から見えた起業理由について語る動画が公開",
    content: "RENEW LLC.様のYouTubeチャンネルにて、弊社代表の起業に至るまでの体験談が公開されました。3度の詐欺被害や死の淵から見えた起業理由について語っています。",
    date: "2024年12月23日",
    category: "メディア",
    author: "広報部",
    tags: ["YouTube", "RENEW MEDIA", "起業理由"],
    views: 0,
    url: "https://youtu.be/OzoInQcnhSU"
  },
  {
    id: 33,
    title: "RENEW MEDIA YouTube動画公開（起業家編）",
    summary: "17歳から量子コンピュータ、21歳で2社経営のディープテック起業家に迫る動画が公開",
    content: "RENEW LLC.様のYouTubeチャンネルにて、弊社代表のプロフィールと事業内容について紹介いただきました。17歳から量子コンピュータに興味を持ち、21歳で2社を経営するまでの軌跡をご覧いただけます。",
    date: "2024年12月10日",
    category: "メディア",
    author: "広報部",
    tags: ["YouTube", "RENEW MEDIA", "起業家"],
    views: 0,
    url: "https://youtu.be/OzoInQcnhSU"
  },
  {
    id: 32,
    title: "コーポレート写真を撮影していただきました",
    summary: "プロフェッショナルなコーポレート写真の撮影を実施",
    content: "株式会社DeepTeLLのコーポレート写真を撮影していただきました。今後の企業広報活動において活用してまいります。",
    date: "2024年11月24日",
    category: "お知らせ",
    author: "広報部",
    tags: ["コーポレート写真", "撮影"],
    views: 0
  },
  {
    id: 31,
    title: "QRL論文リポスト",
    summary: "QRL: 量子リザーバコンピューティングとベイジアンネットワークを組み合わせた言語ベース因果推論手法",
    content: "杉本迅、谷前太喜による論文「QRL: An Integrated Approach Combining QuantumReservoir Computing and Bayesian Networks forLanguage-Based Causal Reasoning」をリポストいたします。",
    date: "2024年11月20日",
    category: "技術",
    author: "技術広報",
    tags: ["QRL", "量子リザーバ", "ベイジアンネットワーク", "論文"],
    views: 0,
    url: "https://deep-recommend.blog/deeptech-ja/qrl-an-integrated-approach-combining-quantumreservoir-computing-and-bayesian-networks-forlanguage-based-causal-reasoning/"
  },
  {
    id: 30,
    title: "量子コンピューティングEXPO初日終了",
    summary: "第5回量子コンピューティングEXPO秋の初日が成功裏に終了",
    content: "2024年11月20日から開催されている第5回量子コンピューティングEXPO秋の初日が無事終了いたしました。多くの皆様にお越しいただき、ありがとうございました。",
    date: "2024年11月20日",
    category: "イベント",
    author: "イベント担当",
    tags: ["量子EXPO", "幕張メッセ", "展示"],
    views: 0
  },
  {
    id: 29,
    title: "次世代データ解析基盤「量子リザーバ × 時系列予測」資料公開",
    summary: "取締役COO杉本迅による量子リザーバを活用した時系列予測技術の資料を公開",
    content: "取締役COO杉本迅による「次世代データ解析基盤『量子リザーバ × 時系列予測』」に関する資料を公開いたします。量子技術を活用した革新的な時系列予測手法についてご紹介しています。",
    date: "2024年11月18日",
    category: "技術",
    author: "技術広報",
    tags: ["量子リザーバ", "時系列予測", "データ解析"],
    views: 0,
    url: "https://speakerdeck.com/deeptell/ci-shi-dai-detajie-xi-ji-pan-liang-zi-rizaba-x-shi-xi-lie-yu-ce-qu-di-yi-cooshan-ben-xun-d6f1b594-a720-4a1c-a74f-f351137cf820"
  },
  {
    id: 28,
    title: "blueqat共同出展企業として紹介",
    summary: "第5回量子コンピューティングEXPO秋にてblueqat様との共同出展企業として紹介",
    content: "2024年11月20日～22日に幕張メッセで開催される第5回量子コンピューティングEXPO秋において、blueqat様との共同出展企業として弊社が紹介されました。",
    date: "2024年11月15日",
    category: "イベント",
    author: "イベント担当",
    tags: ["blueqat", "共同出展", "量子EXPO"],
    views: 0,
    url: "https://blueqat.com"
  },
  {
    id: 27,
    title: "量子EXPO秋 直前オンラインセミナー登壇決定",
    summary: "2024年11月18日開催のウェビナーに杉本迅が登壇します",
    content: "2024年11月18日17:00-19:30に開催される「量子EXPO秋 直前オンラインセミナー」に、取締役COO杉本迅が登壇いたします。量子コンピューティングの最新動向についてお話しします。",
    date: "2024年11月13日",
    category: "イベント",
    author: "イベント担当",
    tags: ["ウェビナー", "量子EXPO", "blueqat"],
    views: 0,
    url: "https://blueqat.com"
  },
  {
    id: 26,
    title: "量子コンピューティングEXPOの来場案内を共有",
    summary: "NexTech Week 2024 量子コンピューティングEXPOの来場案内",
    content: "2024年11月20日～22日に幕張メッセで開催される量子コンピューティングEXPOの来場案内を共有いたします。最新の量子技術をご覧いただける貴重な機会です。",
    date: "2024年11月10日",
    category: "イベント",
    author: "イベント担当",
    tags: ["量子EXPO", "NexTech Week", "来場案内"],
    views: 0,
    url: "https://nextech-week.jp"
  },
  {
    id: 25,
    title: "Quantum Reservoir Computing論文リポスト",
    summary: "DeepRecommend: 時系列予測と分類のための量子リザーバコンピューティング新フレームワーク",
    content: "「Quantum Reservoir Computing: A Novel Framework for Time-Series Prediction and Classification」に関する論文をリポストいたします。時系列データの予測と分類における革新的なアプローチについて解説しています。",
    date: "2024年11月4日",
    category: "技術",
    author: "技術広報",
    tags: ["量子リザーバ", "時系列予測", "論文"],
    views: 0,
    url: "https://deep-recommend.blog/アーカイブ-ja-ja/quantum-reservoir-computing-a-novel-frameworkfor-time-series-prediction-and-classification/"
  },
  {
    id: 24,
    title: "人材紹介マッチング「コルピア」HPを公開",
    summary: "人材紹介マッチングサービス「コルピア」の公式ホームページを公開",
    content: "人材紹介マッチングサービス「コルピア」の公式ホームページを公開いたします。AIを活用した効率的な人材マッチングサービスをご提供いたします。",
    date: "2024年10月22日",
    category: "製品情報",
    author: "製品開発部",
    tags: ["CorPia", "人材マッチング", "ホームページ"],
    views: 0,
    url: "https://main.d3abbsc92ul2qw.amplifyapp.com"
  },
  {
    id: 23,
    title: "ひとしごとアドバイザーに掲載",
    summary: "谷前・杉本がアドバイザーとして「ひとしごとアドバイザー」に掲載されました",
    content: "弊社の谷前太喜、杉本迅が、ひとしごとアドバイザーにアドバイザーとして掲載されました。キャリア相談や事業相談などでお役に立てるよう努めてまいります。",
    date: "2024年10月21日",
    category: "お知らせ",
    author: "広報部",
    tags: ["アドバイザー", "ひとしごと", "キャリア相談"],
    views: 0,
    url: "https://hitoshigoto-adviser.co.jp"
  },
  {
    id: 22,
    title: "あしざるFCさんと交流",
    summary: "経営者仲間とサッカー観戦、チャンネル登録者272万人の「あしざるFC」さんと交流",
    content: "経営者仲間とのサッカー観戦にて、チャンネル登録者272万人を誇るYouTubeチャンネル「あしざるFC」の皆様と交流させていただきました。",
    date: "2024年10月20日",
    category: "交流",
    author: "広報部",
    tags: ["あしざるFC", "サッカー", "交流"],
    views: 0,
    url: "https://youtube.com/@ashisalfc?si=V6HcSVsNkJpSWLiq"
  },
  {
    id: 21,
    title: "YouTubeチャンネル「DeepTeLL【AIを日常に】」動画公開",
    summary: "公式YouTubeチャンネルの動画コンテンツを公開開始",
    content: "株式会社DeepTeLLの公式YouTubeチャンネル「DeepTeLL【AIを日常に】」にて、初回動画を公開いたします。AIの日常活用について分かりやすく解説してまいります。",
    date: "2024年10月17日",
    category: "メディア",
    author: "広報部",
    tags: ["YouTube", "AIを日常に", "動画"],
    views: 0,
    url: "https://youtube.com"
  },
  {
    id: 20,
    title: "CorPia公式LINEアカウントを開設",
    summary: "人材マッチングサービス「CorPia」の公式LINEアカウントを開設",
    content: "人材マッチングサービス「CorPia」の公式LINEアカウントを開設いたします。より手軽にサービスをご利用いただけるよう、LINEを通じたサポートを開始いたします。",
    date: "2024年10月16日",
    category: "製品情報",
    author: "製品開発部",
    tags: ["CorPia", "LINE", "アカウント開設"],
    views: 0,
    url: "https://line.me"
  },
  {
    id: 19,
    title: "「中小企業のための0円AI活用術～経営者交流会～」チケット申し込み開始",
    summary: "経営者向けAI活用セミナーのチケット販売を開始",
    content: "「中小企業のための0円AI活用術～経営者交流会～」のチケット申し込みを開始いたします。中小企業の経営者様を対象に、コストをかけずにAIを活用する方法についてお伝えします。",
    date: "2024年10月13日",
    category: "イベント",
    author: "イベント担当",
    tags: ["セミナー", "経営者交流会", "AI活用"],
    views: 0,
    url: "https://aicommunicationseminar.peatix.com"
  },
  {
    id: 18,
    title: "登記情報が掲載されました",
    summary: "株式会社DeepTeLLの登記情報が法人情報サイトに掲載",
    content: "株式会社DeepTeLL（東京都港区）の登記情報が法人情報サイトに正式に掲載されました。企業の透明性を確保し、信頼性の向上に努めてまいります。",
    date: "2024年10月11日",
    category: "お知らせ",
    author: "総務部",
    tags: ["登記情報", "法人情報", "transparency"],
    views: 0,
    url: "https://houjin.jp"
  },
  {
    id: 17,
    title: "MarpとChatGPTを使った資料作成方法の記事を公開",
    summary: "効率的な資料作成手法についてnoteで記事を公開",
    content: "MarpとChatGPTを活用した効率的な資料作成方法について、note記事として公開いたします。プレゼンテーション資料の作成時間を大幅に短縮する手法をご紹介しています。",
    date: "2024年10月10日",
    category: "技術",
    author: "技術広報",
    tags: ["Marp", "ChatGPT", "資料作成", "note"],
    views: 0,
    url: "https://note.com"
  },
  {
    id: 16,
    title: "人材マッチングサービス「CorPia（コルピア）」提案資料を公開",
    summary: "AIを活用した人材マッチングサービスの提案資料をSpeaker Deckで公開",
    content: "人材マッチングサービス「CorPia（コルピア）」の提案資料をSpeaker Deckにて公開いたします。AIを活用した効率的な人材マッチングの仕組みについて詳しく解説しています。",
    date: "2024年9月29日",
    category: "製品情報",
    author: "製品開発部",
    tags: ["CorPia", "人材マッチング", "提案資料"],
    views: 0,
    url: "https://speakerdeck.com"
  },
  {
    id: 15,
    title: "生成AI業務効率化実例資料を公開",
    summary: "企業における生成AI活用の実例をまとめた資料をSpeaker Deckで公開",
    content: "企業における生成AI業務効率化の実例をまとめた資料をSpeaker Deckにて公開いたします。実際の導入事例とその効果について詳しくご紹介しています。",
    date: "2024年9月29日",
    category: "技術",
    author: "技術広報",
    tags: ["生成AI", "業務効率化", "実例"],
    views: 0,
    url: "https://speakerdeck.com"
  },
  {
    id: 14,
    title: "DeepTeLL事業説明資料を公開",
    summary: "株式会社DeepTeLLの事業内容を詳しく説明した資料をSpeaker Deckで公開",
    content: "株式会社DeepTeLLの事業内容を詳しく説明した資料をSpeaker Deckにて公開いたします。当社のビジョン、技術、サービス内容について包括的にご紹介しています。",
    date: "2024年9月29日",
    category: "企業情報",
    author: "広報部",
    tags: ["事業説明", "会社概要", "ビジョン"],
    views: 0,
    url: "https://speakerdeck.com"
  },
  {
    id: 13,
    title: "Instagramアカウントを開設しました",
    summary: "株式会社DeepTeLLの公式Instagramアカウントを開設",
    content: "株式会社DeepTeLLの公式Instagramアカウントを開設いたします。日々の活動や技術情報、チームの様子などを視覚的にお伝えしてまいります。",
    date: "2024年8月9日",
    category: "お知らせ",
    author: "広報部",
    tags: ["Instagram", "SNS", "アカウント開設"],
    views: 0,
    url: "https://instagram.com/deeptell_inc?igsh=MXNva2hwcGIzMm15dw%3D%3D&utm_source=qr"
  },
  {
    id: 12,
    title: "ホームページを作成しました",
    summary: "株式会社DeepTeLLの公式ホームページを公開",
    content: "株式会社DeepTeLLの公式ホームページを作成し、公開いたします。当社のサービス、技術、チーム情報などを包括的にご紹介しています。",
    date: "2024年8月7日",
    category: "お知らせ",
    author: "広報部",
    tags: ["ホームページ", "公開", "ウェブサイト"],
    views: 0,
    url: "https://deeptell.co.jp"
  }
]; 